import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import InputBase from '@material-ui/core/InputBase';
import Icon from '@material-ui/core/Icon';
//import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import { isEmpty, CellType, DicVal, ByteLeft, toStringDate, isNumber, PadZero, FormatDate, isDate, Floor, tagformat, replaceall, DeepCopy} from '../../modules/appLibrary';
import { entryrerender, entrydata } from '../../modules/formstore';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

//--------------------------------------------------------
//  Entery Input
//
//  fnc
//  def：カラム情報
//  dataRef : 入力データ
//  textfields : 入力項目リスト（キー制御用）
//--------------------------------------------------------
// Event
//  changewidth
//  ValueChanged
//  ※データをメモリに保存　rerender防止対策
//--------------------------------------------------------
export default function HinbanEntryInput(props) {
    const basestyle = { flex: 1 };
    const inputEl = useRef(null)
    const focusvalue = useRef(null)
    const valueChangedOptionsRef = useRef(null)
    const activeSearchDefRef = useRef(null)

    const formstatus = useSelector(state => state.form.status);
    const warndescription = useSelector(state => state.form.warndiscription);
    const entrylock = useSelector(state => state.form.entryformlock);
    const inputrender = useSelector(state => state.form.entryinputrender);
    const applylinkfield = useSelector(state => state.form.applylinkfield);
    const applyfieldid = useSelector(state => state.form.applyfieldid);
    const storeentrydata = useSelector(state => state.form.entrydata);
    const account = useSelector(state => state.user.account);
    const [value, setbasevalue] = useState('');
    const [checktext, setText] = useState('');
    const [apptext, setappText] = useState('');
    const [placeholder, setplaceholder] = useState('');
    const [name, setbasename] = useState('');
    const [mark, setmark] = useState(null);
    const [style, setStyle] = useState(basestyle);
    const [warning, setwarning] = useState('');
    const dispatch = useDispatch();

    const CELLTYPE = CellType();
    const elemid = props.def.columnid + "_" + props.def.type;
    const elemcmdid = props.def.columnid + "_cmd_" + props.def.type;
    const sectionLock = !!props.sectionLock;
    const effectiveFormStatus = props.forceNewFormMode ? 'NEW FORM' : formstatus;
    const displayValueMap = props.def.displayValueMap || null;
    const displayValueSourceColumn = DicVal(props.def, "displayValueSourceColumn", props.def.columnid);
    const displayDefaultValue = DicVal(props.def, "displayDefaultValue", "");
    const displayMappedInEntryForm = effectiveFormStatus === 'ENTRY FORM' && !isEmpty(displayValueMap);
    const displaySourceValue = displayMappedInEntryForm && displayValueSourceColumn !== props.def.columnid
        ? DicVal(props.dataRef.current, resolveDataKey(props.dataRef.current, displayValueSourceColumn), "")
        : value;
    const rotRoundRule = resolveRotRoundRuleValue();
    const brandHinbanNumberingRule = resolveBrandHinbanNumberingRuleValue();
    const isRotRoundField = rotRoundRule !== null;
    const forceRotRoundEditable = isRotRoundField && !rotRoundRule.locked && !rotRoundRule.unchange;
    const inputLock = entrylock || sectionLock;
    const effectiveLocked = rotRoundRule !== null ? rotRoundRule.locked : (brandHinbanNumberingRule === null ? props.def.locked : (!!props.def.locked || brandHinbanNumberingRule.locked));
    const effectiveUnchange = rotRoundRule !== null ? rotRoundRule.unchange : (brandHinbanNumberingRule === null ? props.def.unchange : (!!props.def.unchange || brandHinbanNumberingRule.unchange));
    const effectivePrimary = brandHinbanNumberingRule === null ? props.def.primary : false;
    const effectiveEditableOnNewFormOnly = brandHinbanNumberingRule === null ? props.def.editableOnNewFormOnly : false;
    const newFormOnlyReadOnly = !!effectiveEditableOnNewFormOnly && effectiveFormStatus !== 'NEW FORM';
    const manualInputLocked = !!DicVal(props.def, "manualInputLocked", false);
    const readOnly = forceRotRoundEditable
        ? inputLock || newFormOnlyReadOnly || manualInputLocked || (effectivePrimary && effectiveFormStatus === 'ENTRY FORM')
        : effectiveLocked || inputLock || newFormOnlyReadOnly || manualInputLocked || ((effectivePrimary || effectiveUnchange) && effectiveFormStatus === 'ENTRY FORM') || displayMappedInEntryForm;
    const renderedValue = displayMappedInEntryForm
        ? DicVal(displayValueMap, String(isEmpty(displaySourceValue) ? "" : displaySourceValue), displayDefaultValue)
        : value;
    const hideDisplayName = !!DicVal(props.def, "hideDisplayName", false);
    const showCustomSearchButton = !isEmpty(props.QuerySearchClick) && (props.def.columnid === "PDT_TENKAICODE" || props.def.columnid === "PDT_SBRCODE");
    const hideCommandButton = (props.commandEnabled === false) || (readOnly && !manualInputLocked) ||
        (!props.def.history &&
            !showCustomSearchButton &&
            (props.def.datatype === CELLTYPE.TEXT || props.def.datatype === CELLTYPE.TEXTAREA || props.def.datatype === CELLTYPE.NUM ||
                props.def.datatype === CELLTYPE.STICKY || props.def.datatype === CELLTYPE.CHECK || props.def.datatype === CELLTYPE.APPROVAL || props.def.datatype === CELLTYPE.RADIO));

    useEffect(() => {
        if (isEmpty(props.dataRef.current)) return;
        //外部で変更された値を反映
        const dataKey = resolveDataKey(props.dataRef.current, props.def.columnid);
        if (dataKey in props.dataRef.current) {
            const currentValue = props.dataRef.current[dataKey];
            const currentName = props.def.datatype === CELLTYPE.MASTER
                ? DicVal(props.dataRef.current, resolveDataKey(props.dataRef.current, props.def.columnid + "_nm"), "")
                : "";
            if (value !== currentValue) {
                ShowValue();
            } else if (props.def.datatype === CELLTYPE.MASTER && name !== currentName) {
                // 値が同じで名称だけ違うときは名称を取り込むだけにする。
                // ここで再照会すると、該当なしマスタの '' と他パネルで導出された名称が
                // 交互に書き込まれる振動が永続する。
                setbasename(currentName);
            }
        }
    }, [inputrender]);

    useEffect(() => {
        if (props.ignoreStoreEntryData) return;
        if (isEmpty(storeentrydata)) return;
        const dataKey = resolveDataKey(storeentrydata, props.def.columnid);
        if (!(dataKey in storeentrydata)) return;
        const currentValue = storeentrydata[dataKey];
        const currentName = props.def.datatype === CELLTYPE.MASTER
            ? DicVal(storeentrydata, resolveDataKey(storeentrydata, props.def.columnid + "_nm"), "")
            : "";
        if (value !== currentValue) {
            ShowValueFromData(storeentrydata);
        } else if (props.def.datatype === CELLTYPE.MASTER && name !== currentName) {
            // 値が同じで名称だけ違うときは名称を取り込むだけにする(上と同じ理由)。
            setbasename(currentName);
        }
    }, [storeentrydata]);

    useEffect(() => {
        if (isEmpty(props.dataRef.current)) return;
        if (props.def.columnid === applyfieldid) {
            let data = props.dataRef.current;
            if (isEmpty(DicVal(data, applyfieldid, ""))) return;
            LinkFieldApply(props.def, data[applyfieldid]);
        }
    }, [applylinkfield]);

    useEffect(() => {
        if (isEmpty(warndescription)) return;
        let result = warndescription.find(e => e.col === props.def.columnid);
        if (isEmpty(result)) {
            if (!isEmpty(warning)) setwarning("");
            return;
        }
        setwarning(result.message);
    }, [warndescription]);

    useEffect(() => {
        //if (props.def.datatype === CELLTYPE.NUM) {
        //    setStyle({ width: 'auto' });
        //}
        if (props.def.datatype === CELLTYPE.MASTER || props.def.datatype === CELLTYPE.SELECT || props.def.datatype === CELLTYPE.SPIN) {
            setStyle({ width: 'auto' });
        }
        setplaceholder(Placeholder());
        function Placeholder() {
            var params = DicVal(props.def, "searchparam");
            if (isEmpty(params)) return '';
            return DicVal(params, "placeholder");
        }
    }, [props.def]);

    useEffect(() => {
        ShowValue();
    }, []);

    function shouldDeferStoreSync() {
        return matchesColumnToken(props.def.columnid, "ROTROUND") && props.def.datatype === CELLTYPE.NUM;
    }
    function setValue(value, syncStore = true) {
        setbasevalue(value);
        if (!syncStore || isEmpty(props.dataRef.current)) return;
        let id = props.def.columnid;
        // 同じ値なら store を更新しない。更新すると全画面が再描画される。
        if (props.dataRef.current[id] === value) return;
        var newdata = { ...props.dataRef.current };
        newdata[id] = value;
        props.dataRef.current = newdata;
        //v1.4
        dispatch(entrydata({ ...newdata }));  //コピーを送る
    }
    function setName(name) {
        if (props.def.datatype === CELLTYPE.MASTER) {
            if (!isEmpty(props.dataRef.current)) {
                //MASTERの名称をセット
                let id = props.def.columnid + "_nm";
                // 同じ値なら store を更新しない。
                // 更新すると再描画が起き、その描画がまた同じマスタ照会を出すため、
                // 該当なしのマスタ項目で無限ループになる。
                if (props.dataRef.current[id] !== name) {
                    var newdata = { ...props.dataRef.current };
                    newdata[id] = name;
                    props.dataRef.current = newdata;
                    //v1.4
                    dispatch(entrydata({ ...props.dataRef.current }));  //コピーを送る
                }
            }
        }
       setbasename(name);
    }

    function ShowValue() {
        ShowValueFromData(props.dataRef.current);
    }
    // 標準(EntryInput.ShowValue→ValueFormat)と同じ数値表示整形(カンマ区切り/0や空は空欄)。
    // 表示のみ整形し、entrydata へは書き戻さない(初期表示で store を変更しないため)。
    function formatNumericDisplayValue(value) {
        if (isEmpty(value)) return '';
        const format = String(DicVal(props.def, 'format', '') ?? '');
        const num = Floor(Number(replaceall(String(value), ',', '')), props.def.decimalplace);
        if (isNaN(num) || num === 0) return '';
        if (format.indexOf('unuseGrouping') !== -1) return num.toString();
        if (props.def.decimalplace === 0) return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return num.toLocaleString(undefined, {
            minimumFractionDigits: props.def.decimalplace,
            maximumFractionDigits: props.def.decimalplace
        });
    }
    function ShowValueFromData(data) {
        const columnKey = resolveDataKey(data, props.def.columnid);
        const nameKey = resolveDataKey(data, props.def.columnid + "_nm");
        if (props.def.datatype === CELLTYPE.STICKY) {
            if (!isEmpty(data)) {
                let value = data[columnKey];
                if (!isEmpty(value)) {
                    setbasevalue(value.note);
                    setmark({ "mark": value.mark, "color": value.color });
                    return;
                }
            }
            setbasevalue('');
            setmark(null);
        } else if (props.def.datatype === CELLTYPE.CHECK) {
            if (!isEmpty(data)) {
                setbasevalue(data[columnKey])
                SetCheckText(data[columnKey]);
            } else {
                setbasevalue("0");
                SetCheckText("0");
            }
        } else if (props.def.datatype === CELLTYPE.APPROVAL) {
            if (!isEmpty(data)) {
                setbasevalue(data[columnKey])
                SetApprovalText(data[columnKey]);
            } else {
                setbasevalue("0");
                SetApprovalText("0");
                setappText('');
            }
        } else {
            if (!isEmpty(data)) {
                if (props.def.datatype === CELLTYPE.DATE) {
                    // 独自ロード経路(加工指示データ等)は時分秒付きの文字列で届くことがあるため
                    // 表示は日付部分のみに整形する。標準ロードの値(yyyy/MM/dd)は FormatDate が素通しする。
                    const rawDate = DicVal(data, columnKey, "");
                    setbasevalue(isEmpty(rawDate) ? "" : (isDate(rawDate) ? FormatDate(rawDate) : rawDate));
                    return;
                }
                if (props.def.datatype === CELLTYPE.MASTER) {
                    const currentValue = DicVal(data, columnKey, "");
                    const currentName = DicVal(data, nameKey, "");
                    setbasevalue(currentValue);
                    if (isEmpty(currentValue)) {
                        setbasename("");
                        return;
                    }
                    if (!isEmpty(currentName)) {
                        setbasename(currentName);
                        return;
                    }
                    setbasename("");
                    ValueFormat(currentValue);
                    return;
                }
                if (props.def.datatype === CELLTYPE.NUM) {
                    setbasevalue(formatNumericDisplayValue(DicVal(data, columnKey, "")));
                    return;
                }
                setbasevalue(data[columnKey]);
                if (props.def.datatype === CELLTYPE.SELECT || props.def.datatype === CELLTYPE.SPIN) {
                    let result = props.def.options.find(e => e.code === data[columnKey]);
                    if (!isEmpty(result)) setbasename(result.name);
                    else setbasename('');
                }
            } else {
                setbasevalue("");
            }
        }
    }
    function matchesColumnId(columnid, target) {
        return String(isEmpty(columnid) ? "" : columnid).trim().toUpperCase() === String(isEmpty(target) ? "" : target).trim().toUpperCase();
    }
    function matchesColumnToken(columnid, target) {
        const left = String(isEmpty(columnid) ? "" : columnid).trim().toUpperCase();
        const right = String(isEmpty(target) ? "" : target).trim().toUpperCase();
        return left === right || left.endsWith(right) || left.includes(right);
    }
    function resolveDataKey(data, columnid) {
        if (isEmpty(data) || isEmpty(columnid)) return columnid;
        const keys = Object.keys(data);
        const exact = keys.find((key) => matchesColumnId(key, columnid));
        if (!isEmpty(exact)) return exact;
        return keys.find((key) => matchesColumnToken(key, columnid)) || columnid;
    }
    function resolveChangedDataId(colinfo = props.def, data = props.dataRef.current) {
        const defaultDataId = DicVal(colinfo, "dataid", "");
        const params = DicVal(colinfo, "searchparam", null);
        const chgsearchid = DicVal(params, "chgsearchid", "");
        if (isEmpty(chgsearchid) || isEmpty(data)) return defaultDataId;
        const items = chgsearchid.split(",");
        if (items.length < 2) return defaultDataId;
        const condition = items[0].split("=");
        if (condition.length < 2) return defaultDataId;
        const key = condition[0];
        const expectedValue = condition.slice(1).join("=");
        return String(DicVal(data, key, "")).trim() === expectedValue
            ? items[1].replace(/：/g, ":")
            : defaultDataId;
    }
    function dataid(colinfo = props.def, data = props.dataRef.current) {
        return resolveChangedDataId(colinfo, data);
    }
    function resolveMasterDisplayColumn(colinfo = props.def) {
        let key = DicVal(colinfo, "dbcolumn", "");
        if (!isEmpty(key) && key.indexOf("dbo") !== -1) {
            key = "fnc_" + colinfo.columnid;
        }
        return key;
    }
    function resolveMasterDisplayName(master, colinfo = props.def) {
        if (isEmpty(master)) return "";
        const key = resolveMasterDisplayColumn(colinfo);
        if (!isEmpty(key) && master[key] !== undefined && master[key] !== null) {
            return master[key];
        }
        return DicVal(master, "name", "");
    }
    function hydrateMasterName(colinfo, code, sourceData = props.dataRef.current) {
        if (isEmpty(code) || isEmpty(props.fnc.current) || typeof props.fnc.current.getMasterdata !== "function") return;
        const currentDataId = dataid(colinfo, sourceData);
        const others = [{ columnid: colinfo.columnid, dbcolumn: colinfo.dbcolumn }];
        props.fnc.current.getMasterdata(currentDataId, code, "", others, sourceData, (masterData) => {
            if (isEmpty(masterData)) return;
            if (typeof props.fnc.current.setMaster === "function") {
                props.fnc.current.setMaster(masterData);
            }
            const currentRow = props.dataRef.current;
            const currentKey = resolveDataKey(currentRow, colinfo.columnid);
            if (DicVal(currentRow, currentKey, "") !== code) return;
            setName(resolveMasterDisplayName(masterData, colinfo));
        });
    }
    function resolveRotRoundRuleValue() {
        if (!matchesColumnToken(props.def.columnid, "ROTROUND")) return null;
        const source = !isEmpty(storeentrydata) ? storeentrydata : props.dataRef.current;
        const flagKey = resolveDataKey(source, "PDT_ROTCHANGEFLG");
        const flagValue = String(DicVal(source, flagKey, "")).trim();
        if (flagValue === "0") return { locked: true, unchange: true };
        if (flagValue === "1") return { locked: false, unchange: false };
        return null;
    }
    function isBrandHinbanNumberingControlledField() {
        const dataid = String(DicVal(props.def, "dataid", "")).trim().toUpperCase();
        const label = String(DicVal(props.def, "columnnm", "")).trim();
        return matchesColumnId(DicVal(props.def, "columnid", ""), "PDT_SYOHINCD") || dataid === "UNUSENO" || label === "ブランド品番連番";
    }
    function resolveBrandHinbanNumberingRuleValue() {
        if (!isBrandHinbanNumberingControlledField()) return null;
        const source = !isEmpty(storeentrydata) ? storeentrydata : props.dataRef.current;
        const numberingKey = resolveDataKey(source, "__hinban_numbering_select__");
        const numberingValue = String(DicVal(source, numberingKey, "0")).trim();
        if (numberingValue === "1") return { locked: false, unchange: false };
        return { locked: true, unchange: true };
    }
    function applovalenabled() {
        let srcflg = DicVal(props.dataRef.current, props.def.columnid + "_cd", '0'); //元値
        if (srcflg === "0" || srcflg === 0) return true;
        if (!isEmpty(props.def.dbcolumn.split(",")[1])) {
            let appdcd = DicVal(props.dataRef.current, props.def.dbcolumn.split(",")[1], '');
            return appdcd === account;
        }
        return false;
    }
    function SetApprovalText(value) {
        let ok = '承認';
        let ng = '否認';
        let off = '';
        if (!isEmpty(props.def.options)) {
            let item = props.def.options.find(e => e.code === "1");
            if (!isEmpty(item)) ok = item.name;
            item = props.def.options.find(e => e.code === "2");
            if (!isEmpty(item)) ng = item.name;
        }

        let srcflg = DicVal(props.dataRef.current, props.def.columnid + "_cd", '0'); //元値
        let appddate = '';
        if (!isEmpty(props.def.dbcolumn.split(",")[0])) {
            appddate = DicVal(props.dataRef.current, props.def.dbcolumn.split(",")[0],'');
        }
        let appdnm = ''
        if (!isEmpty(props.def.dbcolumn.split(",")[0])) {
            appdnm = DicVal(props.dataRef.current, props.def.dbcolumn.split(",")[1] + "_nm", '');
            appdnm = ByteLeft(appdnm, 6);
        }
        if (value === "1" || value === 1) {
            setText(ok);
            if (srcflg === "1" || srcflg === 1) setappText(appdnm + " " + appddate);
            else setappText("");
            return;
        }
        if (value === "2" || value === 2) {
            setText(ng);
            if (srcflg === "2" || srcflg === 2) setappText(appdnm + " " + appddate);
            else setappText("");
            return;
        }
        setText(off);
        setappText('');
    }
    function SetCheckText(value) {
        let on = '';
        let off = '';
        if (!isEmpty(props.def.options)) {
            let item = props.def.options.find(e => e.code === "1");
            if (!isEmpty(item)) on = item.name;
            item = props.def.options.find(e => e.code === "0");
            if (!isEmpty(item)) off = item.name;
        }
        setText(value === "1" || value === 1 ? on : off);
    }
    function onChange(id, value, edit) {
        //変更データをメモリ上に保存
        let data = { ...props.dataRef.current };
        if (isEmpty(data)) data = {};
        if (props.def.datatype === CELLTYPE.STICKY) {
            data[id] = {"note":value, "mark": mark===null?'':mark.mark, "color": mark===null?'':mark.color };
        } else {
            data[id] = value;
        }
        props.dataRef.current = data;
        if(props.def.columnid === id){
            ValueChanged(value,edit);
        }
    }
    function onMarkChange(id, newmark) {
        //変更データをメモリ上に保存
        let data = { ...props.dataRef.current };
        if (isEmpty(data)) data = {};
        if (props.def.datatype === CELLTYPE.STICKY) {
            data[id] = { "note": value, "mark": newmark === null ? '' : newmark.mark, "color": newmark === null ? '' : newmark.color };
        }
        props.dataRef.current = data;
    }

    function isLock() {
        return effectiveLocked || inputLock || newFormOnlyReadOnly || ((props.def.primary || effectiveUnchange) && effectiveFormStatus === 'ENTRY FORM');
    }
    function onClick() {
        if (isEmpty(inputEl.current)) return;
        inputEl.current.focus();
    }
    function ApprovalClick() {
        if (value !== "0" && value !== 0) {
            if (!applovalenabled()) return;     //承認者以外
        }
        var newvalue = "1";
        if (value === "1" || value === 1) newvalue = "2";
        if (value === "2" || value === 2) newvalue = "0";
        setValue(newvalue);
        SetApprovalText(newvalue);
        onChange(props.def.columnid, newvalue,true);
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, newvalue);
        focusvalue.current = newvalue;
    }
    function SwitchClick(e) {
        if (isLock()) return;
        var newvalue = "";
        var newname = "";
        if (isEmpty(value)) {
            newvalue = props.def.options[0].code;
            newname = props.def.options[0].name;
        } else {
            var idx = props.def.options.findIndex(e => e.code === value);
            if (props.def.options.length - 1 === idx) {
                newvalue = props.def.options[0].code;
                newname = props.def.options[0].name;
            } else {
                newvalue = props.def.options[idx+1].code;
                newname = props.def.options[idx+1].name;
            }
        }
        setValue(newvalue);
        setName(newname);
        onChange(props.def.columnid, newvalue,true);
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, newvalue, true);
        focusvalue.current = newvalue;
    }
    function ButtonClick() {
        function openSearch(definition) {
            activeSearchDefRef.current = definition;
            props.fnc.current.searchlistopen({
                label: definition.columnnm,
                multiple: definition.multiple || definition.datatype === CELLTYPE.TAG,
                rowmode: definition.multiple && definition.datatype !== CELLTYPE.MASTERREF,
                data: definition,
                rowdata: { ...props.dataRef.current },
                doApply: setsearchitem
            });
        }
        function handleCustomSearchResult(newdef) {
            if (newdef === false) return true;
            if (!isEmpty(newdef)) {
                openSearch(newdef);
                return true;
            }
            return false;
        }
        if (!isEmpty(props.QuerySearchClick)) {
            let newdef = props.QuerySearchClick(props.def, props.dataRef.current);
            if (!isEmpty(newdef) && typeof newdef.then === "function") {
                newdef.then((resolved) => {
                    handleCustomSearchResult(resolved);
                }).catch(() => {
                    props.fnc.current.warnmsg("検索候補の取得に失敗しました");
                });
                return;
            }
            if (handleCustomSearchResult(newdef)) return;
        }
        //検索リストOPEN
        openSearch(props.def);
    }
    function setsearchitem(e) {
        const searchDef = isEmpty(activeSearchDefRef.current) ? props.def : activeSearchDefRef.current;
        props.fnc.current.modify();
        valueChangedOptionsRef.current = { source: "searchlist" };
        var newvalue = e.value;
        if (searchDef.datatype === CELLTYPE.TAG) {
            var newtag = tagformat(e.value + " " + value);
            if (value.split(' ').length !== newtag.split(' ').length || isEmpty(value)) {     //TAG追加あり
                setValue(newtag);
                onChange(searchDef.columnid, newtag,true);
                newvalue = newtag;
            }
        } else if (searchDef.datatype === CELLTYPE.STICKY) {
            setmark({ "mark": e.value, "color": e.color });
            onMarkChange(searchDef.columnid, e.value);
        } else if (searchDef.datatype === CELLTYPE.DATE) {
            setValue(toStringDate(e.value));
            if (!isEmpty(props.ValueChanged)) {
                props.ValueChanged(searchDef.columnid, toStringDate(e.value));
            }
        } else if (searchDef.datatype === CELLTYPE.SELECT || searchDef.datatype === CELLTYPE.SPIN) {
            setValue(e.value);
            setName(e.items[0].data.name);
            onChange(searchDef.columnid, e.value,true);
            //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, e.value);
        } else if (searchDef.datatype === CELLTYPE.MASTERREF) {
            let value = "";
            for (let i = 0; i < e.items.length; i++) {
                if (i !== 0) value += " ";
                value += e.items[i].data[e.datainfo.dbcolumn];
            }
            setValue(value);
            onChange(searchDef.columnid, value,true);
            newvalue = value;
        } else if (searchDef.history) {
            let value = e.items[0].data["code"];
            setValue(value);
            onChange(searchDef.columnid, value,true);
            newvalue = value;
        } else {
            setValue(e.value);
            if (searchDef.datatype === CELLTYPE.MASTER && !isEmpty(e.items) && !isEmpty(e.items[0]) && !isEmpty(e.items[0].data)) {
                const nameValue = resolveMasterDisplayName(e.items[0].data, searchDef);
                setName(nameValue);
            }
            onChange(searchDef.columnid, e.value,true);
            LinkFieldApply(searchDef, e.value);
            //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, e.value);
        }
        activeSearchDefRef.current = null;
        props.fnc.current.searchlistclose();
    }
    function LinkFieldApply(colinfo, value) {
        //参照カラムを取得
        let others = colinfo.trigger;
        if (colinfo.datatype === CELLTYPE.MASTER) {
            others = [...colinfo.trigger, ...[{ columnid: colinfo.columnid, dbcolumn: colinfo.dbcolumn }]];
        }
        const currentDataId = dataid(colinfo, props.dataRef.current);
        if (!props.fnc.current.existMaster(currentDataId, value)) {
            //サーバーより情報を取得
            props.fnc.current.getMasterdata(currentDataId, value, '', others, props.dataRef.current, (data) => callback(data, value));
        } else {
            if (colinfo.datatype === CELLTYPE.MASTERREF) {
                //名称置き換え
                let data = props.fnc.current.getMaster(currentDataId, value);
                setValue(data[colinfo.dbcolumn]);
                onChange(colinfo.columnid, data[colinfo.dbcolumn]);
            }
            if (others.length !== 0) {  //関連セットするデータあり
                let data = props.fnc.current.getMaster(currentDataId, value);
                //すべての項目が揃っているかチェック
                let exist = true;
                for (let i = 0; i < others.length; i++) {
                    let key = others[i].dbcolumn;
                    if (key.toUpperCase() === 'NULL') break;    //ブランクにする設定
                    if (key.indexOf('dbo') !== -1) {
                        key = 'fnc_' + colinfo.columnid;
                    }
                    if (data[key] === undefined) {
                        exist = false; break;
                    }
                }
                if (exist) {
                    setLinkfielddata(colinfo, data);
                } else {
                    //サーバーより情報を取得
                    others = others.filter(e => e.dbcolumn.toUpperCase() !== 'NULL');   //ブランクにするを除外
                    props.fnc.current.getMasterdata(currentDataId, value, '', others, props.dataRef.current, (data) => callback(data, value));
                }
            }
        }
    }
    // 中身が同じかどうかを浅く比較する。
    // 変更がないのに entryrerender を通知すると、その再描画が同じマスタ照会を呼び出し、
    // 該当なしの項目で無限ループになる。
    function isSameEntryDataShallow(before, after) {
        if (before === after) return true;
        if (isEmpty(before) || isEmpty(after)) return false;
        const keys = Object.keys(before).concat(Object.keys(after));
        for (let i = 0; i < keys.length; i++) {
            if (before[keys[i]] !== after[keys[i]]) return false;
        }
        return true;
    }
    function setLinkfielddata(col, data) {
        const beforeData = props.dataRef.current;
        if (col.datatype === CELLTYPE.MASTER) {
            if (!isEmpty(data)) {
                setName(resolveMasterDisplayName(data, col));
            }
            else setName('');
        }
        if (isEmpty(col.trigger)) return;
        for (let i = 0; i < col.trigger.length; i++) {
            try {
                if (col.trigger[i].dbcolumn.toUpperCase() === 'NULL') {
                    //ブランクにする
                    onChange(col.trigger[i].columnid, "");
                    continue;
                }
                if (!isEmpty(data)) {
                    if (col.trigger[i].dbcolumn.indexOf("dbo") !== -1) {
                        onChange(col.trigger[i].columnid, data["fnc_" + col.trigger[i].columnid]);
                    } else {
                        onChange(col.trigger[i].columnid, data[col.trigger[i].dbcolumn]);
                    }
                } else {
                    let coldef = props.textfields.find(e => e.columnid === col.trigger[i].columnid);
                    if (isEmpty(coldef)) continue;
                    //マスタにない場合でロックセルの場合クリア
                    if (coldef.locked) {
                        //他からのトリガをチェック
                        if (ExistTriggerData(col.trigger[i].columnid, col)) {
                            onChange(col.trigger[i].columnid, "");
                        }
                    }
                }
            } catch { }
        }
        //関連項目に変更を通知(書き換えが起きたときだけ)
        if (!isSameEntryDataShallow(beforeData, props.dataRef.current)) {
            dispatch(entryrerender());
        }
    }
    function ExistTriggerData(colid, col) {
        //指定colidをトリガに持つcolumnidの値がすべてブランクかどうか
        let cols = props.textfields.filter(e => e.trigger.length !== 0 && e.columnid !== col.columnid);
        for (let i = 0; i < cols.length; i++) {
            if ((Array.isArray(cols[i].trigger) ? cols[i].trigger : []).some(e => !isEmpty(e) && e.columnid === colid)) {
                if (!isEmpty(DicVal(props.dataRef.current, cols[i].columnid))) return false;
            }
        }
        return true;
    }
    function onInputChange(newvalue) {
        if (shouldDeferStoreSync()) {
            setbasevalue(newvalue);
        } else {
            setValue(newvalue);
        }
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
    }
    function onCheckChange(newcheck) {
        if (effectiveLocked || inputLock) return false;
        setValue(newcheck ? "1" : "0");
        SetCheckText(newcheck ? "1" : "0");
        onChange(props.def.columnid, newcheck ? "1" : "0", true);
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, newcheck ? "1" : "0");
        focusvalue.current = newcheck ? "1" : "0";
    }
    function onRadioChange(newvalue) {
        if (effectiveLocked || inputLock) return false;
        setValue(newvalue);
        onChange(props.def.columnid, newvalue, true);
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        focusvalue.current = newvalue;
        restoreFocus();
    }
    function restoreFocus() {
        window.requestAnimationFrame(() => {
            if (!isEmpty(inputEl.current)) {
                inputEl.current.focus();
                return;
            }
            let focusEl = document.getElementById(elemid);
            if (!isEmpty(focusEl)) focusEl.focus();
        });
    }
    function onKeyDown(e) {
        if (props.def.datatype === CELLTYPE.CHECK && e.keyCode === 32) {
            e.preventDefault();
            onCheckChange(!(value === "1" || value === 1));
            restoreFocus();
            return;
        }
        if (e.keyCode === 13) {
            e.preventDefault();
            if (!(props.def.datatype === CELLTYPE.MASTER || props.def.datatype === CELLTYPE.MASTERREF ||
                props.def.datatype === CELLTYPE.MASTERCODE || props.def.datatype === CELLTYPE.MASTERASST)) {
                ValueFormat(e.target.value);
            }
            let key = "";
            var items = props.textfields.filter(e => e.type === props.def.type);
            for (let i = 0; i < items.length; i++) {
                if (items[i].columnid === props.def.columnid) {
                    if (e.shiftKey) {
                        if (i === 0) 
                            key = items[items.length - 1].columnid + "_" + items[items.length - 1].type;
                        else
                            key = items[i - 1].columnid + "_" + items[i - 1].type;
                    } else {
                        if (i === items.length-1)
                            key = items[0].columnid + "_" + items[0].type;
                        else
                            key = items[i + 1].columnid + "_" + items[i + 1].type;
                    }
                    break;
                }
            }
            if (key !== "") {
                try {
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
    function onFocus(e) {
        focusvalue.current = value;
        if (props.def.datatype === CELLTYPE.NUM) {
            setbasevalue(replaceall(value, ",", ""));
        }
        inputEl.current.select();
   }
    function onBlur(e) {
        if (readOnly) return;
        const dataKey = resolveDataKey(props.dataRef.current, props.def.columnid);
        let oldvalue = "";
        if (!isEmpty(props.dataRef.current)) oldvalue = props.dataRef.current[dataKey];
        let change = e.target.value !== oldvalue;
        onChange(props.def.columnid, e.target.value,true);
        //手入力
        let value = e.target.value;
        if (change && (props.def.datatype === CELLTYPE.MASTER || props.def.datatype === CELLTYPE.MASTERREF ||
            props.def.datatype === CELLTYPE.MASTERCODE || props.def.datatype === CELLTYPE.MASTERASST)) {
            if (props.def.length !== 0 && props.def.format.indexOf('padzero') !== -1) {
                if (isNumber(value)) {
                    //ゼロサプレス
                    value = PadZero(value, props.def.length);
                    setValue(value);
                    onChange(props.def.columnid, value,true);
                }
            }
            //マスタ連携項目セット
            LinkFieldApply(props.def, value);
        } else {
            ValueFormat(e.target.value);
        }
    }
    function callback(data,value) {
        if (!isEmpty(data) && props.fnc.current !== null) {
            props.fnc.current.setMaster(data);
        }
        if (!isEmpty(data)) {
            if (props.def.datatype === CELLTYPE.MASTERREF) {
                //名称置き換え
                setName(data[props.def.dbcolumn]);
            }
        }
        setLinkfielddata(props.def, data);
        ValueChanged(value);
    }
    function ValueChanged(newvalue,edit) {
        if (isEmpty(props.ValueChanged)) return;
        const options = valueChangedOptionsRef.current;
        valueChangedOptionsRef.current = null;
        if (isEmpty(focusvalue.current)) {
            props.ValueChanged(props.def.columnid, newvalue, edit, options);
            focusvalue.current = newvalue;
        }
        else {
            if (focusvalue.current !== newvalue || edit) {
                props.ValueChanged(props.def.columnid, newvalue,edit, options);
                focusvalue.current = newvalue;
            }
        }
    }
    function ValueFormat(value) {
        if (props.def.length !== 0 && props.def.format.indexOf('padzero') !== -1) {
            if (isNumber(value)) {
                //ゼロサプレス
                value = PadZero(value, props.def.length);
                setValue(value);
                onChange(props.def.columnid, value);
            }
        }
        if (props.def.datatype === CELLTYPE.DATE) {
            if (!isDate(value)) {
                setValue('');
                onChange(props.def.columnid, "");
                ValueChanged("");
                return;
            }
            value = FormatDate(value);
        }
        if (props.def.datatype === CELLTYPE.NUM) {
            if (isEmpty(value)) {
                setValue('', !shouldDeferStoreSync());
                onChange(props.def.columnid, "");
                ValueChanged("");
                return;
            }
            let num = Floor(Number(value), props.def.decimalplace);
            if (isNaN(num) || num === 0) {
                setValue('', !shouldDeferStoreSync());
                onChange(props.def.columnid, "");
                ValueChanged("");
                return;
            }
            let newvalue = "";
            if (props.def.format.indexOf('unuseGrouping') !== -1) { //カンマ区切りなし
                newvalue = num.toString();
            } else {
                if (props.def.decimalplace === 0) {
                    newvalue = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                } else {
                    newvalue = num.toLocaleString(undefined, {
                        minimumFractionDigits: props.def.decimalplace,
                        maximumFractionDigits: props.def.decimalplace
                    });
                }
            }
            setValue(newvalue, !shouldDeferStoreSync());
            ValueChanged(newvalue);
            return;
        }
        if (props.def.datatype === CELLTYPE.MASTER) {
            if (isEmpty(value)) {
                setName('');
                ValueChanged("");
                return;
            }
            const currentDataId = dataid(props.def, props.dataRef.current);
            let others = [{ columnid: props.def.columnid, dbcolumn: props.def.dbcolumn }];
            let data = props.fnc.current.getMaster(currentDataId, value);
            if (data !== null) {
                const displayName = resolveMasterDisplayName(data, props.def);
                if (!isEmpty(displayName)) {
                    setValue(value);
                    setName(displayName);
                    ValueChanged(value);
                    return;
                }
            }
           //サーバーより情報を取得
            props.fnc.current.getMasterdata(currentDataId, value, '', others, props.dataRef.current, (data) => callback(data, value));
            return;
        }
        if (props.def.datatype === CELLTYPE.SELECT || props.def.datatype === CELLTYPE.SPIN) {
            let result = props.def.options.find(e => e.code === value);
            if (!isEmpty(result))
                setName(result.name);
            else {
                value = "";
                setName('');
            }
        }

        if (isEmpty(value)) setValue('');
        else setValue(value);
        ValueChanged(isEmpty(value)?"":value);
    }


    function SizeChange(e) {
        if (e.shiftKey) {
            e.preventDefault();
            if (!isEmpty(props.changewidth))
                props.changewidth(props.def, e.deltaY);
        }
    }
    function Stickymark() {
        if (props.def.datatype !== CELLTYPE.STICKY) return null;
        if (mark !==null) {
            return <IconButton size="small" onClick={!effectiveLocked && !inputLock ? ButtonClick : null} disabled={inputLock}>
                <Icon style={{ color: mark.color }}>{mark.mark}</Icon>
            </IconButton>
        } else {
            return <IconButton size="small" onClick={!effectiveLocked && !inputLock ? ButtonClick : null} disabled={inputLock}>
                <Icon>arrow_right</Icon>
            </IconButton>
        }
    }
    function applovalicon(value) {
        if (value === "1" || value === 1) {
            return <Icon style={{ color: '#1ABC9C' }}>verified_user</Icon>
        }
        if (value === "2" || value === 2) {
            return <Icon style={{ color: '#E74C3C' }}>gpp_bad</Icon>
        }
        return <Icon>crop_free</Icon>
    }
    function iconcursor() {
        if (effectiveLocked || inputLock) return 'default';
        if (props.def.datatype === CELLTYPE.CHECK) return 'pointer';
        if (applovalenabled()) return 'pointer';
        else return 'not-allowed'
    }
    function InputCheck() {
        let cursor = iconcursor();
        if (props.def.datatype === CELLTYPE.RADIO) {
            return (
                <div style={{ marginLeft:8 }}>
                <RadioGroup
                    row
                    value={isEmpty(value) ? "" : value}
                    onChange={(e) => onRadioChange(e.target.value)}
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: '12px',
                            lineHeight: 1,
                        },
                        '& .MuiRadio-root': {
                            padding: '2px',
                        },
                        '& .MuiRadio-root.Mui-checked': {
                            color: '#87877c',
                        },
                    }}
                >
                        {(props.def.options || []).map((option, index) => (
                            <FormControlLabel
                                key={option.code}
                                value={option.code}
                                control={
                                    <Radio
                                        size="small"
                                        disabled={inputLock}
                                        id={(option.code === value) || (isEmpty(value) && index === 0) ? elemid : undefined}
                                        inputRef={(option.code === value) || (isEmpty(value) && index === 0) ? inputEl : null}
                                        onKeyDown={onKeyDown}
                                    />
                                }
                                label={option.name}
                            />
                        ))}
                    </RadioGroup>
                    </div>
            );            
        }
        if (props.def.datatype === CELLTYPE.CHECK) {
            return (
                <FormControlLabel
                    control={
                        <Checkbox
                            id={elemid}
                            checked={value === "1" || value === 1}
                            inputRef={inputEl}
                            onKeyDown={onKeyDown}
                            onChange={(e) => onCheckChange(e.target.checked)}
                            onWheel={(e) => SizeChange(e)}
                            size = "small"
                            disabled={inputLock}
                            sx={{
                                p: 0.4,   // Checkbox 自体の余白を小さく
                                marginLeft:1,
                                "&.Mui-checked": {
                                    color: "#87877c",
                                },
                            }}
                        />
                    }
                    label={checktext}
                    sx={{
                        "& .MuiFormControlLabel-label": {
                            fontSize: "12px",
                            userSelect: "none",
                            lineHeight: 1,
                        },
                    }}                />
            );
        }
        return (
            <React.Fragment>
                <IconButton size="small" style={{ marginLeft: 4, cursor: cursor }}
                    onClick={!effectiveLocked && !inputLock ? ApprovalClick : null} disabled={inputLock}>
                    {applovalicon(value)}
                </IconButton>
                <InputBase style={style}
                    value={checktext}
                    readOnly={true}
                    inputProps={{
                        style: { textAlign: 'left', fontSize: 12 },
                    }}
                    onWheel={(e) => SizeChange(e)}
                />
                <InputBase style={style}
                    value={apptext}
                    readOnly={true}
                    inputProps={{
                        style: { textAlign: 'right', fontSize: 12, marginRight: 5 },
                    }}
                    onWheel={(e) => SizeChange(e)}
                /> 
            </React.Fragment>
        );
    }
    function WarnTip() {
        return (
            <Tooltip title={warning}>
                <div style={{ position: 'absolute', top: -3, left: -8, cursor: 'pointer' }}>
                    <span class="material-icons warning">announcement</span>
                </div>
            </Tooltip>
        );
    }
   return (
        <div style={{ display: 'flex', position: 'relative' }} onClick={onClick}>
            {warning === "" ? null : <WarnTip />}
           <Stickymark />
           {props.def.datatype !== CELLTYPE.CHECK && props.def.datatype !== CELLTYPE.APPROVAL && props.def.datatype !== CELLTYPE.RADIO ?
               <InputBase style={style}
                   id={elemid}
                   value={renderedValue}
                   placeholder={placeholder}
                   readOnly={readOnly}
                   inputProps={{
                       maxLength: props.def.length === 0 || props.def.datatype === CELLTYPE.NUM ? null : props.def.length,
                       style: { textAlign: props.def.datatype === CELLTYPE.NUM ? 'right' : 'left', fontSize: 12, marginRight: props.def.datatype === CELLTYPE.NUM ? 15 : 0},
                       autoComplete: 'off'
                   }}
                   onChange={(e) => onInputChange(e.target.value)}
                   onBlur={onBlur}
                   onFocus={onFocus}
                   onKeyDown={onKeyDown}
                   onWheel={(e) => SizeChange(e)}
                   inputRef={inputEl}
               /> :
                <InputCheck />
           }
           {(props.def.datatype === CELLTYPE.MASTER || props.def.datatype === CELLTYPE.SELECT || props.def.datatype === CELLTYPE.SPIN) && !hideDisplayName ?
                <div style={{ flex: 1, marginLeft: 0, marginTop: 5, color: '#555', whiteSpace: 'nowrap', fontSize:12 }}>{name}</div> : null}
           {hideCommandButton ? null :
                <div id={elemcmdid} >
                   {props.def.datatype === CELLTYPE.SPIN ?
                        <IconButton size="small" onClick={() => SwitchClick()} disabled={effectiveLocked || inputLock}>
                           <Icon>unfold_more</Icon>
                        </IconButton>
                    :
                       <IconButton size="small" onClick={() => ButtonClick()} disabled={effectiveLocked || inputLock}>
                           <Icon>arrow_right</Icon>
                       </IconButton>
                    }
                </div>
            }
        </div>
    );
}






